import {
  PointerEvent as ReactPointerEvent,
  KeyboardEvent as ReactKeyboardEvent,
} from "react";
import { Modal } from "../Modal/Modal.tsx";
import { SuperZoomImage } from "./SuperZoomImage.tsx";
import { GalleryObject, ImageClickPosition } from "../utils/utils.ts";

export interface SuperZoomModalProps {
  isOpen: boolean;
  mediaItems: GalleryObject[];
  selectedIndex: number;
  imageClickPosition: ImageClickPosition;
  onCloseButton: () => void;
  onCloseClick: (
    event:
      ReactPointerEvent<HTMLDivElement> | ReactKeyboardEvent<HTMLDivElement>,
  ) => void;
}

export const SuperZoomModal = ({
  isOpen,
  mediaItems,
  selectedIndex,
  imageClickPosition,
  onCloseButton,
  onCloseClick,
}: SuperZoomModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCloseButton}
      enableBodyScrollOverride={false}
    >
      <SuperZoomImage
        mediaItems={mediaItems}
        selectedIndex={selectedIndex}
        imageClickPosition={imageClickPosition}
        onCloseClick={onCloseClick}
        onCloseButton={onCloseButton}
      />
    </Modal>
  );
};
